import { BasicPage } from "apps/oneOnboarding/basic/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(BasicPage, "BasicPage");
